import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import AddAccountSvg from '../../assets/svgs/AddAccount';

const AddAccount = ({ className }) => {
    return (
        <div className={className}>
            <AddAccountSvg />
            <span>افزودن اکانت جدید</span>
        </div>
    );
};

AddAccount.propTypes = {
    className: PropTypes.string.isRequired
};
export default styled(AddAccount)`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0 3px 10px #e8ebff;
    margin-bottom: 12px;
    padding: 13px 25px 13px 33px;
    cursor: pointer;

    > span {
        font-size: 14px;
        font-weight: bold;
        line-height: 25px;
        color: #0d1fa1;
    }

    > svg {
        margin-right: -10px;
        margin-left: 13px;
    }
`;
